import { matchPath, useLocation } from 'react-router-dom-v5-compat'

export function useIsPath(paths: string[]) {
  const location = useLocation()
  const currentPage = location.pathname
  const matchesCurrentPage = (element: string) =>
    !!matchPath(
      {
        path: element,
        end: true,
      },
      currentPage
    )

  return paths.some(matchesCurrentPage)
}
